import { render, staticRenderFns } from "./FilterRecibos.vue?vue&type=template&id=55ab83e0"
import script from "./FilterRecibos.vue?vue&type=script&lang=js"
export * from "./FilterRecibos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports